import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/runner/work/my-mr-lite/my-mr-lite/layouts/default.vue").then(m => m.default || m)),
  error: defineAsyncComponent(() => import("/home/runner/work/my-mr-lite/my-mr-lite/layouts/error.vue").then(m => m.default || m))
}